import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PositionService } from '../../service/position.service';
import { Subscription } from 'rxjs';
import { BitfinexLoan } from '../../../model/BitfinexLoan';
import { ProgressBarModel } from '../../../model/ProgressBarModel';
import { SessionService } from '../../service/session.service';
import { ToastrService } from 'ngx-toastr';
import { Exchange, EXCHANGES } from '../../../model/constants';
import { PERMISSION, UserClient } from '@clearing-hub/common';
import { Router } from '@angular/router';
import { UpdateStaticInfoWidgetComponent } from '@baxter-jenkins/update-static-info-widget';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ChangePasswordWidgetComponent } from '@baxter-jenkins/authenticator';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  EXCHANGES = EXCHANGES;

  dropdownOpen = false;

  @Input()
  currentUser: UserClient;

  @Input()
  maxAllocationAmountPercentage: number;

  @Input()
  accounts: Array<string>;

  @Input()
  notionalLoan: ProgressBarModel;

  @Input()
  activeLoan: ProgressBarModel;

  @Input()
  loan: BitfinexLoan;

  @Input()
  currentFXCHLimit: number;

  @Output()
  pull: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  selectedAccountsChangedEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  enableAllCurrencyForAllAccountEvent: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  disableAllCurrencyForAllAccountEvent: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  handleAccountDisplayEvent: EventEmitter<Array<string>> = new EventEmitter<Array<string>>();

  @ViewChild('error')
  errorTemplate: TemplateRef<any>;

  // @ViewChild('cd', {static: false}) countdown: CountdownComponent;

  counterPaused: boolean;

  // config: CountdownConfig;

  isCounterStarted: boolean;

  showOnlyBitfinexEnabledAccounts = false;

  timeInSeconds = 300;

  selectedAccounts: any[] = [];

  // activeTabName: string;

  activeExchange: Exchange;

  subscriptions: Array<Subscription> = new Array<Subscription>();

  // BFX loan
  // loan: BitfinexLoan;
  loanPrecision = 0;
  //

  isSweepEnabled = true;

  PERMISSION_ENUM = PERMISSION;

  countdown: number;
  countdownDisplay: string;
  private refreshTimerSubscription: Subscription;
  private countdownDuration = 5 * 60;

  private worker: Worker;

  constructor(private readonly positionService: PositionService,
              private readonly sessionService: SessionService,
              private readonly modalService: BsModalService,
              private readonly router: Router,
              private readonly toastr: ToastrService) {
  }

  ngOnDestroy(): void {

  }

  stopCountdown() {
    if (this.refreshTimerSubscription) {
      this.refreshTimerSubscription.unsubscribe();
    }
  }

  updateDisplay(countdown: number) {
    // Convert countdown to HH:MM:SS format and update the display
    const hours = Math.floor(countdown / 3600);
    const minutes = Math.floor((countdown % 3600) / 60);
    const seconds = countdown % 60;
    this.countdownDisplay = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  initWorker() {
    if (typeof Worker !== 'undefined') {
      const blob = new Blob([this.getWorker(this.timeInSeconds)], { type: 'application/javascript' });
      const workerUrl = URL.createObjectURL(blob);
      this.worker = new Worker(workerUrl);

      this.worker.onmessage = ({ data }) => {
        if (data.message) {
          return;
        }
        if (data.count === 0) {
          this.pull.emit();
        }

        if (data.count >= 0) {
          this.updateDisplay(data.count);
        }
      };
      this.worker.postMessage('start');
    } else {
      console.log('Web Workers are not supported in your current browser.');
    }
  }

  restartCountdown() {
    this.worker.postMessage('start');
  }

  ngOnInit(): void {
    if (this.currentUser.permissions.includes(PERMISSION.BITFINEX_READ) || this.currentUser.permissions.includes(PERMISSION.BITFINEX_WRITE)) {
      this.activeExchange = Exchange.BITFINEX;
    }
    this.subscriptions.push(this.positionService.selectTabEvent.subscribe((exchange: Exchange) => {
      this.activeExchange = exchange;
    }));
    const storedSelectedAccounts = this.sessionService.getUserCache()?.selectedAccounts;
    if (storedSelectedAccounts) {
      this.selectedAccounts = storedSelectedAccounts;
    } else {
      this.selectedAccounts = this.accounts;
    }

    this.notionalLoan = new ProgressBarModel(this.loan.maxNotionalLoanSizeInUSD, this.loan.currentNotionalLoanSizeInUSD);
    this.activeLoan = new ProgressBarModel(this.loan.maxActiveLoanSizeInUSD, this.loan.currentActiveLoanSizeInUSD);
    this.updateDisplay(this.timeInSeconds);
    this.initWorker();
  }

  sweep() {
    this.isSweepEnabled = false;
    this.positionService.sweep().subscribe(() => {
      this.isSweepEnabled = true;
      this.toastr.success('Success', null, {disableTimeOut: false});
    }, error => {
      this.isSweepEnabled = true;
      this.toastr.error(error.error);
    });
  }

  pullAll() {
    this.worker.postMessage('stop');
    this.pull.emit();
  }

  getWorker(timeOnSeconds: number) {
    return `
    let countdownValue = ${timeOnSeconds};
    let countdown = countdownValue; // 5 minutes in seconds
let intervalId = null;

self.addEventListener('message', (e) => {

  if (e.data === 'start') {
    if (intervalId) {
      clearInterval(intervalId);
      countdown = countdownValue;
    }
    intervalId = setInterval(() => {
      countdown--;
      postMessage({count: countdown});
      if (countdown <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  } else if (e.data === 'stop') {
    clearInterval(intervalId);
    countdown = countdownValue; // Reset countdown
  } else if (e.data === 'reset') {
    countdown = countdownValue; // Reset countdown to 5 minutes
    postMessage({count: countdown});
  }
});`
  }

  handleAccountDisplay(selectedAccounts: Array<any>) {
    this.handleAccountDisplayEvent.emit(selectedAccounts);
  }

  enableAllCurrencyForAllAccount() {
    this.enableAllCurrencyForAllAccountEvent.emit();
  }

  disableAllCurrencyForAllAccount() {
    this.disableAllCurrencyForAllAccountEvent.emit();
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.sessionService.logout().subscribe(() => {
      this.router.navigateByUrl('');
    }, error => (err) => {
      this.router.navigateByUrl('');
      console.log(err)
    });
  }

  navigateToProfile() {
    // Logic to navigate to Profile Page
  }

  openUpdateStaticDataModal() {
    const modalRef = this.modalService.show(UpdateStaticInfoWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg'
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    })
    modalRef.content.updateResultEvent.subscribe(() => {
      modalRef.hide();
      this.toastr.success('Company successfully modified');
    })
  }

  openChangePasswordModal() {
    const initialState = {
      toastr: this.toastr,
      includeModal: true,
      gridColumnLayout: 12
    }
    const modalRef = this.modalService.show(ChangePasswordWidgetComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      animated: false,
      class: 'modal-lg',
      initialState
    });
    modalRef.content.cancelEvent.subscribe(() => {
      modalRef.hide();
    })
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

}
